import { useContext } from "react";
import useUrlQueryFilters from "components/common/EntityFilters/hooks/useUrlQueryFilters";
import TableFilterContext from "components/common/PaginatedEntityTable/TableFilterContext";
const useAppendTagFilter = () => {
  const tableFilterContext = useContext(TableFilterContext);
  const [urlFilters, setUrlFilters] = useUrlQueryFilters();
  return (tag) => {
    var _a;
    const currentFilters = (_a = tableFilterContext == null ? void 0 : tableFilterContext.searchParams.filters) != null ? _a : urlFilters;
    const existing = currentFilters.get("tags", []);
    if (existing.includes(tag)) return;
    setUrlFilters(currentFilters.set("tags", [...existing, tag]));
  };
};
export default useAppendTagFilter;
